import React from 'react';
import { Container, Body5 } from '@ui';
import { NodeParameterRemoveButton } from '@flow/buttons/NodeParameterRemoveButton';
import { TransparentFlatButton } from '@ui/buttons';
import { isObject } from '@utils/usefulFuncs';
import { AgentFlowParameterWrapper, AgentFlowParameterLabelWrapper, AgentFlowTextarea } from '@flow/styles';

export const ExtendedListParameter = ({ data, value, onRemove, onChange }) => {
  const { keyName, label } = data;

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const syncItems = () => {
      if (Array.isArray(value)) {
        setItems(value);
      } else {
        setItems([value]);
      }
    };
    syncItems();
  }, []);

  React.useEffect(() => {
    onChange(
      keyName,
      items.filter((el) => el !== '')
    );
  }, [items]);
  const handleAddKeyedItem = () => {
    setItems((prevItems) => [...prevItems, { query: '', context_query: '' }]);
  };
  const handleAddItem = () => {
    setItems((prevItems) => [...prevItems, '']);
  };
  const handleChange = (e, i) => {
    const value = e.target.value;
    setItems((prevItems) => {
      const copy = [...prevItems];
      copy[i] = value;
      return copy;
    });
  };
  const handleExtendedListChange = (e, i, key) => {
    const textValue = e.target.value;
    setItems((prevItems) => {
      const copy = [...prevItems];
      copy[i] = { ...copy[i], [key]: textValue };
      return copy;
    });
  };
  const handleRemoveClick = () => {
    onRemove(keyName);
  };

  const handleRemoveItemClick = (i) => {
    setItems((prevItems) => {
      const copy = [...prevItems];
      return copy.filter((el, elIndex) => elIndex !== i);
    });
  };

  return (
    <AgentFlowParameterWrapper>
      <Container fullWidth>
        <Container row verticallyCenter spaceBetween fullWidth>
          <Container row verticallyCenter>
            <AgentFlowParameterLabelWrapper>
              <Body5>{label}:</Body5>
            </AgentFlowParameterLabelWrapper>
            <div className="read-only-hide" style={{ display: 'flex', gap: 8 }}>
              <TransparentFlatButton onClick={handleAddItem}>Add List Item</TransparentFlatButton>
              <TransparentFlatButton onClick={handleAddKeyedItem}>Add Keyed List Item</TransparentFlatButton>
            </div>
          </Container>

          <NodeParameterRemoveButton onClick={handleRemoveClick} />
        </Container>
        <ul>
          {items.map((item, index) => {
            if (isObject(item)) {
              return (
                <li key={index}>
                  <Container fullWidth row verticallyCenter>
                    <Container row fullWidth>
                      <select value={'query'} onChange={(e) => null}>
                        <option value={'query'}>Query</option>
                      </select>
                    </Container>
                    <NodeParameterRemoveButton onClick={() => handleRemoveItemClick(index)} />
                  </Container>
                  <Container fullWidth row top={8} left={16}>
                    <AgentFlowTextarea
                      value={item.query}
                      onChange={(e) => handleExtendedListChange(e, index, 'query')}
                    />
                  </Container>
                  <Container fullWidth row verticallyCenter top={8}>
                    <Container row fullWidth>
                      <select value={'context_query'} onChange={(e) => null}>
                        <option value={'context_query'}>Context Query</option>
                      </select>
                    </Container>
                    <NodeParameterRemoveButton onClick={() => handleRemoveItemClick(index)} />
                  </Container>
                  <Container fullWidth row top={8} left={16}>
                    <AgentFlowTextarea
                      value={item.context_query}
                      onChange={(e) => handleExtendedListChange(e, index, 'context_query')}
                    />
                  </Container>
                </li>
              );
            }

            return (
              <li key={index}>
                <Container fullWidth row verticallyCenter>
                  <AgentFlowTextarea value={item} onChange={(e) => handleChange(e, index)} />
                  <NodeParameterRemoveButton onClick={() => handleRemoveItemClick(index)} />
                </Container>
              </li>
            );
          })}
        </ul>
      </Container>
    </AgentFlowParameterWrapper>
  );
};
